export default __webpack_public_path__ + "static/Retul-road-cool-b598b98d0718d0b626966ad5652648ab.jpg";